import AppsPage from "@/pages/Admin/AppsPage"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/admin/apps")({
  component: AppsPage,
})
